import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function formatUSD(n) {
  if (n == null || Number.isNaN(n)) return "$0";
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
}

export function formatMoney(amount, currency) {
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export default function KPICard({ label, value, current, previous, suffix, testId, tone = "neutral" }) {
  let delta = null;
  const numericCurrent = current != null ? current : (typeof value === "number" ? value : null);
  if (previous != null && previous !== 0 && numericCurrent != null) {
    delta = ((numericCurrent - previous) / Math.abs(previous)) * 100;
  }
  const up = delta != null ? delta >= 0 : null;
  const toneClass =
    tone === "positive" ? "text-emerald-500" : tone === "negative" ? "text-rose-500" : "text-foreground";
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden rounded-xl border border-border/60 bg-card p-5 sm:p-6 transition-colors duration-200 hover:border-border animate-fade-in-up"
    >
      <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
      <div className={`mt-3 text-3xl sm:text-4xl font-heading font-semibold tracking-tight num ${toneClass}`}>
        {value}{suffix}
      </div>
      {delta != null && (
        <div className={`mt-3 inline-flex items-center gap-1 text-xs font-medium ${up ? "text-emerald-500" : "text-rose-500"}`}>
          {up ? <ArrowUpRight className="w-3.5 h-3.5" /> : <ArrowDownRight className="w-3.5 h-3.5" />}
          {Math.abs(delta).toFixed(1)}% <span className="text-muted-foreground font-normal">vs mes anterior</span>
        </div>
      )}
    </div>
  );
}
